module.exports = __webpack_public_path__ + "fonts/187083d4f81722d37049fbf4cf959a7e.svg";